export const getUsers = state => state.users;
export const getIdentityToken = state => state.identityToken;


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/users/getters.js